module.exports = __webpack_public_path__ + "static/media/outline-p4-white3.89cc9b58.png";